export const UPDATE_NETWORK_DEVICE_REQUEST = 'UPDATE_NETWORK_DEVICE_REQUEST'
export function updateNetworkDeviceRequest(networkDeviceId, body) {
    return {
        type: UPDATE_NETWORK_DEVICE_REQUEST,
        networkDeviceId,
        body
    }
}

export const UPDATE_NETWORK_DEVICE_SUCCESS = 'UPDATE_NETWORK_DEVICE_SUCCESS'
export function updateNetworkDeviceSuccess() {
    return {
        type: UPDATE_NETWORK_DEVICE_SUCCESS
    }
}

export const UPDATE_NETWORK_DEVICE_ERROR = 'UPDATE_NETWORK_DEVICE_ERROR'
export function updateNetworkDeviceError() {
    return {
        type: UPDATE_NETWORK_DEVICE_ERROR
    }
}

export const NETWORK_DEVICE_REQUEST = 'NETWORK_DEVICE_REQUEST'
export function networkDeviceRequest(networkDeviceId) {
    return {
        type: NETWORK_DEVICE_REQUEST,
        networkDeviceId
    }
}

export const NETWORK_DEVICE_REQUEST_SUCCESS = 'NETWORK_DEVICE_REQUEST_SUCCESS'
export function networkDeviceRequestSuccess(networkDevice) {
    return {
        type: NETWORK_DEVICE_REQUEST_SUCCESS,
        networkDevice
    }
}

export const NETWORK_DEVICE_REQUEST_ERROR = 'NETWORK_DEVICE_REQUEST_ERROR'
export function networkDeviceRequestError() {
    return {
        type: NETWORK_DEVICE_REQUEST_ERROR
    }
}

export const START_LOADING = 'START_LOADING'
export function startLoading() {
    return {
        type: START_LOADING,
        isLoading: true
    }
}
